import { SelectSingleEventHandler } from "@centricsoftware/design-system";
import { useFormStore, useStatefulFormField } from "csi/middleware/form/index";
import { observer } from "mobx-react-lite";
import React, { ChangeEvent, FunctionComponent, useEffect, useState } from "react";
import { TimeComponent } from "../time/TimeComponent";

export const FormFieldDateTimePicker: FunctionComponent = observer(() => {
	const formStore = useFormStore();
	const field = useStatefulFormField();
	const {
		format,
		id,
		label,
		tooltip,
		transientInfo: {
			disabled,
			readOnly,
			required,
			value,
		},
	} = field;
	const handleFieldChange = formStore?.handleFieldChange;
	const [fieldInvalid, fieldMessage] = formStore?.getFieldError(id) || [false, ""];

	const onSelect: SelectSingleEventHandler = (day: Date): void => {
		handleFieldChange?.(null, field, day?.getTime(), true);
	};

	const onChangeInput = (ev: ChangeEvent<HTMLInputElement>): void => {
		const dateString = ev.target.value;
		if (dateString) {
			const validDate = new Date(dateString);
			if (validDate.getTime()) {
				handleFieldChange?.(null, field, validDate.getTime(), true);
				return;
			}
		}
		handleFieldChange?.(ev, field, undefined, true);
	};

	const onClearDate = (): void => {
		handleFieldChange?.(null, field, undefined, true);
	};

	const onClosePopup = (): void => {
		handleFieldChange?.(null, field, value);
	};

	const [date, setDate] = useState(value ? new Date(value as string) : null);
	useEffect(() => {
		if (value) {
			const numberValue = Number(value);
			let validDate: Date;
			if (isNaN(numberValue)) {
				validDate = new Date(value as string);
			} else {
				validDate = new Date(numberValue);
			}
			setDate(validDate);
		}
	}, [value]);

	return (
		<TimeComponent
			calendarButtonTooltip={tooltip}
			dataCsiAutomation={id}
			disabled={disabled || readOnly}
			format={format}
			invalid={fieldInvalid}
			label={label}
			message={fieldMessage}
			onChange={onChangeInput}
			onClearDate={onClearDate}
			onClosePopup={onClosePopup}
			onSelect={onSelect}
			required={required}
			selected={date}
			value={date}
		/>
	);
});
